export const BEWorkflowSteps = {
    beItinerary: 'beItinerary',
    beVehicleSelection: 'beVehicleSelection',
    beExtras: 'beExtras',
    beReview: 'beReview',
    beConfirmation: 'beConfirmation'
}